export const ClientMappingEnum = {
  CL_ID: "clientId",
  EGN_INS: "insuranceClientPin",
  NAME_INS: "insuranceClientName",
  ADDR_INS: "insuranceClientAddress",
  TEL_INS: "insuranceClientPhone",
  O_DATA: "otherData",
  TYPE_CLIENT: "clientType",
  PIN: "personalIdentificationNumber",
  PCODE: "postalCode",
  EKATTE: "ekatteCode",
  CNTRY: "country",
  E_DIST: "district",
  E_MUNI: "municipality",
};

export const ClientSaveResultMappingEnum = {
  Client_ID: "clientId",
};

export const VehicleMappingEnum = {
  CAR_ID: "carId",
  REG_NO: "vehicleRegistrationNumber",
  MARKA: "vehicleBrand",
  MODEL: "vehicleModel",
  MOTOR: "vehicleVolume",
  VOLUME: "engineCapacity",
  O_DATA: "vehicleOtherData",
  CAR_TYPE: "vehicleType",
  CAR_YR: "manufactureYear",
  CAR_USAGE: "vehicleUsage",
  CHA_NO: "chassisNumber",
  ENG_TYPE: "engineType",
  TALON: "vehicleCertificate",
};

export const AgentMappingEnum = {
  AID: "agentID",
  NAME: "agentName",
  EGN: "personalIdentificationNumber",
  LK_NO: "idCardNumber",
  ADRES: "address",
  PHONE: "phone",
  O_DATA: "otherData",
  IS_ACTIVE: "isActive",
};

export const CommissionMappingEnum = {
  AID: "agentId",
  POLICY: "policyName",
  COMPANY: "companyName",
  PERC: "percentage",
  F_DATE: "startDate",
  OFF: "officeId",
  OTH: "isOtherPolicy",
};

export const OfficeMappingEnum = {
  DIV_ID: "divisionID",
  DIV_NAME: "divisionName",
  MASTER_DIV: "masterDivision",
  IS_ACTIVE: "isActive",
  ZK_AGS: "officeAgencies",
};

export const PolicyMappingEnum = {
  POL_NUM: "policyNumber",
  SUM_POL: "policySum",
  DUES: "installments",
  INS_COMP: "company",
  POL_TYPE: "policyType",
  AGENT: "agent",
  DIV_NAME: "office",
  NAME_INS: "clientName",
  TEL_INS: "clientPhoneNumber",
  REG_NO: "vehicleRegistrationNumber",
  MARKA: "vehicleBrand",
  DATE_B: "fromDate",
  DATE_E: "toDate",
  DATA_POL: "additionalPolicyData",
};

export const PolicyFullMappingEnum = {
  POL_ID: "policyId",
  POL_NUM: "policyNumber",
  CID: "insuranceCompanyId",
  INS_COMP: "insuranceCompany",
  PID: "policyTypeId",
  POL_TYPE: "policyType",
  AID: "agentId",
  AGENT: "agent",
  DIV_ID: "divisionId",
  DIV_NAME: "divisionName",
  DIVISION: "division",
  KIND: "policyStatus",
  SUM_INS: "insuredSum",
  SUM_POL: "policySum",
  DATE_R: "contractDate",
  DATE_B: "startDate",
  DATE_E: "endDate",
  DATE_O: "reportDate",
  DUES: "installmentsCount",
  DATA_POL: "policyAdditionalData",
  CL_ID: "clientId",
  CAR_ID: "carId",
  GF_SUM: "gfSum",
  PRV_PERC_AG: "agentCommissionPercentage",
  REG_NO: "vehicleRegistrationNumber",
  TALON: "vehicleCertificate",
  MARKA: "vehicleBrand",
  MOTOR: "engineCapacity",
  CAR_TYPE: "vehicleType",
  CAR_YR: "manufactureYear",
  CAR_O_DATA: "vehicleOtherData",
  EGN_INS: "insuranceClientPin",
  NAME_INS: "insuranceClientName",
  TEL_INS: "insuranceClientPhone",
  ADDR_INS: "insuranceClientAddress",
  CL_O_DATA: "clientOtherData",
  MODEL: "vehicleModel",
  ZERO_COMM: "zeroCommission",
  VOLUME: "vehicleVolume",
  CAR_USAGE: "vehicleUsage",
  BR_ADD: "additionalCount",
  CHA_NO: "chassisNumber",
  "2PERC": "twoPercentAmount",
  Annex: "annexes",
};

export const PolicySaveMappingEnum = {
  POL_ID: "policyId",
  POL_NUM: "policyNumber",
  CID: "insuranceCompanyId",
  PID: "policyTypeId",
  AID: "agentId",
  KIND: "policyStatus",
  SUM_INS: "insuredSum",
  SUM_POL: "policySum",
  DATE_R: "contractDate",
  DATE_B: "startDate",
  DATE_E: "endDate",
  DATE_O: "reportDate",
  DUES: "installmentsCount",
  DATA_POL: "policyAdditionalData",
  CL_ID: "clientId",
  CAR_ID: "carId",
  GF_SUM: "gfSum",
  DIV_ID: "divisionId",
  PRV_PERC_AG: "agentCommissionPercentage",
  ZERO_COMM: "zeroCommission",
};

export const PolicyReportMappingEnum = {
  Pol_ID: "policyId",
  Pol_Num: "policyNumber",
  InsComp: "insuranceCompany",
  Pol_Kind: "policyType",
  DATE_ND: "installmentDate",
  Green_Card: "greenCardNumber",
  Sticker: "stickerNumber",
  Office: "office",
  Sum_all: "policiesSum",
  Commission: "commissionPercent",
  Sum_Comm: "commissionAmount",
  Pay_Num: "installmentNumber",
  Pay_Off: "paymentPlace",
  Sum_GF: "insuranceFundSum",
  Sum_Stk: "stickerSum",
  Sum_2Perc: "twoPercentSum",
  Total_Sum: "totalSum",
  Sum: "policyAmount",
  StartDate: "startDate",
  EndDate: "endDate",
  DocDate: "policyDate",
  DocNum: "policyNumber",
  Dogovor: "contractType",
  CL_NAME: "clientName",
  EGN: "clientPIN",
};

export const BankReportMappingEnum = {
  POL_ID: "policyId",
  POL_NUM: "policyNumber",
  INS_COMP: "insuranceCompany",
  POL_KIND: "policyType",
  PIN: "personalIdentificationNumber",
  NAME: "clientName",
  DATE_ND: "installmentDate",
  DATE_PAYMENT: "paymentDate",
  PAY_NUM: "installmentNumber",
  SUMA: "installmentAmount",
  REG_NO: "registrationNumber",
  AGENT: "agent",
};

export const DocumentSearchMappingEnum = {
  Agent: "agent",
  Number: "documentNumber",
  InsType: "insuranceType",
  Status: "status",
  POL_ID: "policyId",
  InsComp: "insuranceCompany",
  Pol_Num: "policyNumber",
};

export const DocumentLogMappingEnum = {
  Date: "date",
  Valior: "valior",
  Agent: "agent",
  Action: "action",
  User: "user",
};

export const ClientPolicyMappingEnum = {
  POL_ID: "policyId",
  POL_NUM: "policyNumber",
  INS_COMP: "insuranceCompany",
  POL_TYPE: "policyType",
  DIV_NAME: "office",
  SUM_POL: "policySum",
  DATE_B: "fromDate",
  DATE_E: "toDate",
  DUES: "installments",
  REG_NO: "vehicleRegistrationNumber",
  NAME_INS: "clientName",
  TEL_INS: "clientPhoneNumber",
};

export const VehiclePolicyMappingEnum = {
  POL_ID: "policyId",
  DKN: "registrationNumber",
  Marka: "brand",
  Engine: "enginePower",
  Year: "year",
  PolNum: "policyNumber",
  InsComp: "insuranceCompany",
  KindIns: "insuranceType",
  EndDate: "endDate",
};

export const AgentReportMappingEnum = {
  Pol_ID: "policyId",
  Pol_Num: "policyNumber",
  InsComp: "insuranceCompany",
  Pol_Kind: "policyType",
  DATE_ND: "installmentDate",
  Green_Card: "greenCardNumber",
  Sticker: "stickerNumber",
  Office: "office",
  Sum_all: "policiesSum",
  Commission: "commissionPercent",
  Sum_Comm: "commissionAmount",
  Pay_Num: "installmentNumber",
  Pay_Off: "paymentPlace",
  Sum_GF: "insuranceFundSum",
  Sum_Stk: "stickerSum",
  Sum_2Perc: "twoPercentSum",
};

export const AnnexMappingEnum = {
  ADD_ID: "annexId",
  POL_ID: "policyNumber",
  SUM_INS: "insuredSum",
  SUM_POL: "policySum",
  DATE_R: "contractDate",
  DATE_B: "startDate",
  DATE_O: "reportDate",
  DATA_POL: "policyAdditionalData",
  SM_NUM: "paymentAccount",
  DIV_ID: "divisionId",
  DATE_E: "endDate",
};

export const PolicyValuesMappingEnum = {
  POL_ID: "policyId",
  DATE_ND: "installmentDate",
  SMKA_ND: "accountNumber",
  SUMA_ND: "installmentAmount",
  PAY_NUM: "installmentSequence",
  DIV_ID: "paymentLocation",
  STK_ND: "sticker",
  AG_PAID: "paidToAgent",
  AID: "agentId",
  DATE_PAY: "reportDate",
  STK_SUM: "stickerAmount",
  TWO_PERC: "twoPercentAmount",
  SZK_ND: "greenCardCertificate",
  BANK_PAY: "paidInBank",
  DATE_BANK_PAY: "bankPaymentDate",
  DOC_PAY: "agentPaymentDate",
  DOC_PAY_ZK: "documentNumber",
  PayPlace: "placeOfPayment",
  ZK_PAID: "paidToInsurer",
};

export const InstallmentMappingEnum = {
  POL_NUM: "policyNumber",
  POL_TYPE: "policyType",
  INS_COMP: "insuranceCompany",
  AGENT: "agent",
  DIV_NAME: "divisionName",
  DATE_ND: "paymentDate",
  REG_NO: "vehicleRegistrationNumber",
  MARKA: "vehicleBrand",
  NAME_INS: "clientName",
  TEL_INS: "clientPhoneNumber",
  SUMA_ND: "policySum",
  PAY_NUM: "installments",
  PayPlace: "placeOfPayment",
  "2PERC": "twoPercentAmount",
  DATA_POL: "additionalPolicyData",
};

export const NewPolicyMappingEnum = {
  PID: "policyId",
  BASE_TYPE: "baseType",
  NAME: "name",
};

export const InsuranceCompanyMappingEnum = {
  CID: "companyId",
  NAME: "companyName",
  ADRES: "address",
  PHONE: "phone",
  O_DATA: "otherData",
  IN_REPORT: "isInReport",
  IS_ACTIVE: "isActive",
  BASE_ZK: "baseInsuranceCompany",
  O_CNTR: "reportNumber",
};

export const UserMappingEnum = {
  UID: "uid",
  L_NAME: "fullName",
  U_NAME: "userName",
  DIVS: "divisions",
  U_GROUP: "userGroup",
  uPass: "password",
  is_user: "isUser",
};

export const BrokerReportMappingEnum = {
  Date: "contractDate",
  InsComp: "insuranceCompany",
  Insured: "insuredIdentifier",
  PIN: "personalId",
  Adres: "insuredAddress",
  InsType: "insuranceType",
  PolNum: "policyNumber",
  DateBegin: "startDate",
  DateEnd: "endDate",
  InsPrem: "insurancePremium",
  Commission: "commissionAmount",
  TypeContr: "contractType",
  GFSum: "insuranceFundSum",
  StickerSum: "stickerSum",
  "2PercSum": "twoPercentSum",
  SZK: "claimReference",
  Date_VN: "paymentDate",
  REG_NO: "registrationNumber",
};

export const DailyReportMappingEnum = {
  "2PercSum": "twoPercentSum",
  Agent: "agent",
  AgentPay: "agentPaymentStatus",
  CommAgent: "commissionAgentPercentage",
  CommOff: "commissionOfficePercentage",
  GFSum: "insuranceFundSum",
  InsComp: "insuranceCompany",
  InsPrem: "insurancePremium",
  InsType: "insuranceType",
  PayPlace: "paymentLocation",
  PolNum: "policyNumber",
  SZK: "claimReference",
  Smetka: "accountNumber",
  Sticker: "stickerNumber",
  StickerSum: "stickerSum",
  SumCommAgent: "commissionAgentAmount",
  SumCommOff: "commissionOfficeAmount",
  TypeContr: "contractType",
  Total_Sum: "totalSum",
};

export const SummaryReportMappingEnum = {
  Count: "count",
  NewContracts: "newContracts",
  Time: "time",
};
